
import { supabase } from '../client';

/**
 * Migrate stock updates from localStorage to Supabase
 */
export const migrateStockUpdates = async (userId: string, localStockUpdates: any[]) => {
  if (localStockUpdates.length === 0) {
    console.log('No stock updates to migrate');
    return { count: 0, success: true };
  }

  console.log(`Migrating ${localStockUpdates.length} stock updates`);
  const result = { count: 0, success: true };
  
  for (const update of localStockUpdates) {
    try {
      const { error } = await supabase
        .from('stock_updates')
        .upsert({
          id: update.id,
          product_id: update.productId,
          user_id: userId,
          quantity: update.quantity,
          date: update.date instanceof Date ? update.date.toISOString() : update.date
        });

      if (error) {
        console.error('Error migrating stock update:', error);
        result.success = false;
      } else {
        result.count++;
      }
    } catch (error) {
      console.error('Error processing stock update:', error);
      result.success = false;
    }
  }
  
  return result;
};

/**
 * Migrate usage records from localStorage to Supabase
 */
export const migrateUsageRecords = async (userId: string, localUsageRecords: any[]) => {
  if (localUsageRecords.length === 0) {
    console.log('No usage records to migrate');
    return { count: 0, success: true };
  }

  console.log(`Migrating ${localUsageRecords.length} usage records`);
  const result = { count: 0, success: true };
  
  for (const record of localUsageRecords) {
    try {
      const { error } = await supabase
        .from('usage_records')
        .upsert({
          id: record.id,
          product_id: record.productId,
          user_id: userId,
          quantity: record.quantity,
          output_volume: record.outputVolume,
          color: record.color,
          consistency: record.consistency,
          notes: record.notes,
          date: record.date instanceof Date ? record.date.toISOString() : record.date
        });

      if (error) {
        console.error('Error migrating usage record:', error);
        result.success = false;
      } else {
        result.count++;
      }
    } catch (error) {
      console.error('Error processing usage record:', error);
      result.success = false;
    }
  }
  
  return result;
};
